/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Review_SafeInputs */

const en_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review-safe`)
};

const ar_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آمن للمراجعة`)
};

const bn_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিভিউ-সেফ`)
};

const de_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertungssicher`)
};

const es_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseña segura`)
};

const fr_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révision sécurisée`)
};

const pt_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão segura`)
};

const zh_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审查安全`)
};

const tr_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İnceleme açısından güvenli`)
};

const ru_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасно для просмотра`)
};

const pl_svchip_review_safe = /** @type {(inputs: Svchip_Review_SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możliwość sprawdzenia`)
};

/**
* | output |
* | --- |
* | "Review-safe" |
*
* @param {Svchip_Review_SafeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_review_safe = /** @type {((inputs?: Svchip_Review_SafeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Review_SafeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_review_safe(inputs)
	if (locale === "bn") return bn_svchip_review_safe(inputs)
	if (locale === "de") return de_svchip_review_safe(inputs)
	if (locale === "es") return es_svchip_review_safe(inputs)
	if (locale === "fr") return fr_svchip_review_safe(inputs)
	if (locale === "pt") return pt_svchip_review_safe(inputs)
	if (locale === "zh") return zh_svchip_review_safe(inputs)
	if (locale === "tr") return tr_svchip_review_safe(inputs)
	if (locale === "ru") return ru_svchip_review_safe(inputs)
	if (locale === "pl") return pl_svchip_review_safe(inputs)
	return en_svchip_review_safe(inputs)
});